import createMapEditorPlayer from '../player/createMapEditorPlayer'
import createEngineForUI from './createEngineForUI'

export default function createEngineWithTwoPlayersForUI() {
  const engine = createEngineForUI()
  const { state } = engine
  state.players.push(createMapEditorPlayer(state, state.rng))
  return engine
}
